import { motion } from "framer-motion";

type Props = {
  layoutId?: string;
  heightClassName?: string;
};

const NavbarBackgroundIndicator = ({ layoutId = "navbarIndicator", heightClassName = "h-14" }: Props) => {
  return (
    <div className={`absolute left-1/2 top-1/2 w-full max-w-20 -translate-x-1/2 -translate-y-1/2 ${heightClassName}`}>
      <motion.div
        layoutId={layoutId}
        className="absolute left-0 top-0 h-full w-full rounded-lg bg-[radial-gradient(ellipse_at_center,rgba(255,252,250,0.35),rgba(255,252,250,0.22))]"
        transition={{
          type: "tween",
          ease: [0.45, 0, 0.25, 1], // cubic-bezier
          duration: 0.45,
        }}
      />
    </div>
  );
};

export default NavbarBackgroundIndicator;
